@if (audioService.audioSource.length && baseService.isMobile) {
  <div class="py-2 d-flex justify-content-center">
    <app-audio-player></app-audio-player>
  </div>
}
